import React from "react";
import { Box, Paper, Typography, Button, Stack } from "@mui/material";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import HomeIcon from "@mui/icons-material/Home";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        p: 2,
      }}
    >
      <Paper sx={{ p: 6, maxWidth: 480, width: "100%", textAlign: "center" }}>
        <SentimentDissatisfiedIcon sx={{ fontSize: 80, color: "text.disabled", mb: 2 }} />
        <Typography variant="h3" sx={{ fontWeight: 700, color: "primary.main", mb: 1 }}>
          404
        </Typography>
        <Typography variant="h6" gutterBottom>
          Página não encontrada
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          O endereço acessado não existe ou foi movido.
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="center">
          <Button variant="outlined" onClick={() => navigate(-1)}>
            Voltar
          </Button>
          <Button variant="contained" startIcon={<HomeIcon />} onClick={() => navigate("/")}>
            Início
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
